import {
    getData,
} from './Services'

export const getSliders = async () => {
    const res = await getData('/sliders');
    return res
}
